import React, {useState} from 'react';
import {FieldValues, useForm} from 'react-hook-form'
import {Link, useNavigate} from 'react-router-dom';
import CustomerService from "../services/CustomerService";
import classNames from "classnames";
import {useCookies} from "react-cookie";
import {useAppDispatch} from "../store";
import {changeUser} from "../store/slice/auth";

const USERNAME_COOKIE = "CustomerPortalUsername";
const ONE_YEAR_SECONDS = 31536000; // approx

function LoginPage() {

    const [ errorMessage, setErrorMessage ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState(false);
    const { register, handleSubmit } = useForm();
    const { formState: { errors } } = useForm();
    const [ cookies, setCookie, removeCookie ] = useCookies([USERNAME_COOKIE]);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const defaultEmail = cookies[USERNAME_COOKIE];

    const onSubmit = (data: FieldValues)=>  {

        const { email, password, rememberMe } = data;

        setLoading(true);
        setErrorMessage(null);

        CustomerService.login(email, password)
            .then((/*response*/) => {

                if (rememberMe) {
                    setCookie(USERNAME_COOKIE, email, {
                        sameSite: 'strict',
                        maxAge: ONE_YEAR_SECONDS
                    });
                } else {
                    removeCookie(USERNAME_COOKIE)
                }

                CustomerService.getMe()
                    .then((response) => {
                        dispatch(changeUser(response.data));
                        navigate({pathname: '/deliveries'});
                    })
                    .catch((error) => {
                        if (error.response && error.response.status) {
                            switch (error.response.status) {
                                case 401:
                                case 403:
                                    setErrorMessage('Unable to login');
                                    dispatch(changeUser(null));
                                    break;
                                default:
                                    // fall through
                            }
                        }
                        setErrorMessage("Unable to login")
                    });
            })
            .catch((error) => {
                setLoading(false);
                if (error.response && error.response.status) {
                    switch (error.response.status) {
                        case 401:
                        case 403:
                            setErrorMessage(error.response.data.messages[0] || 'Invalid email and or password');
                            return;
                        case 429:
                            setErrorMessage(error.response.data.messages[0]);
                            return;
                        default:
                            // fall through
                    }
                }
                setErrorMessage('An unexpected error occurred')
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6 col-sm-12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h1 className="h3 p-3 font-weight-normal text-center">Sign in</h1>

                        {errorMessage &&
                            <div className="alert alert-danger" role="alert">
                                {errorMessage}
                            </div>
                        }

                        <div className="mb-3">
                            <label htmlFor="emailAddress" className="form-label sr-only">Email</label>
                            <input
                                {...register("email", {
                                    required: "Required",
                                })}
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                required
                                autoFocus
                                defaultValue={defaultEmail}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="password" className="form-label sr-only">Password</label>
                            <input
                                {...register("password", {
                                    required: "Required",
                                })}
                                type="password"
                                className={classNames('form-control',
                                    {'is-invalid': errors.password},
                                )}
                                placeholder="Password"
                                required
                            />
                            <div className="invalid-feedback">Please enter your password</div>
                        </div>

                        <div className="mb-3 form-check">
                            <input
                                {...register("rememberMe", {})}
                                className="form-check-input"
                                type="checkbox"
                                id="rememberMe"
                                defaultChecked={true}
                            />
                            <label className="form-check-label" htmlFor="rememberMe">Remember me?</label>
                        </div>


                        <div className="d-grid gap-2">
                            <button className="btn btn-lg btn-primary" type="submit" disabled={loading}>
                                {loading && <span className="spinner-border float-start" role="status" aria-hidden="true" />}
                                {loading ? 'Signing in...' : 'Sign in' }
                            </button>
                        </div>


                        <p>
                            <Link className="nav-item nav-link" to="/forgot-password">Forgot your password?</Link>
                        </p>

                    </form>
                </div>
            </div>
        </div>
    );

}

export default LoginPage;
